export {default as CompaniesAdmin} from './CompaniesAdmin'
export { default as companiesAdminStore } from "./companies_admin.store";
// export { default as fakeStore } from './fake_store'



// WEBPACK FOOTER //
// ./src/modules/admin/modules/CompaniesAdmin/index.ts